import axios from '../axios'



// 查询所有的自律项
export const queryAllSelfTrainItems = data => {
    return axios({
        url: '/api/selftrain/queryAllSelfTrainItems',
        method: 'post',
        data
    })
}

// 完成自律
export const finishSelfTrainItem = data => {
    return axios({
        url: '/api/selftrain/finishSelfTrainItem',
        method: 'post',
        data
    })
}
